import Location from 'react-app-location';

export const PhoneEntryLocation = new Location('/phone/entry');
